module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "satc-wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$emit('skip')
      }
    }
  }, [_c('div', {
    ref: "satc",
    staticClass: "satc",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-label": _vm.i18n.title,
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "satc__header",
    style: ({
      backgroundColor: _vm.headerColor
    })
  }, [_c('div', {
    staticClass: "satc__close icon__bg-circle",
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": _vm.i18n.skip
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('skip')
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.$emit('skip')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.$emit('skip')
      }]
    }
  }, [_c('span', {
    staticClass: "icon-cross2",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.introText))]), _vm._v(" "), (_vm.headerSubtitle) ? _c('div', {
    staticClass: "satc__header__subtitle"
  }, [_vm._v(_vm._s(_vm.headerSubtitle))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "satc__body"
  }, [_c('div', {
    staticClass: "satc__date"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n.from_date))]), _vm._v(" "), _c('DateSelector', {
    attrs: {
      "date": _vm.fromDate,
      "width100": true
    },
    on: {
      "changed": _vm.setFromDate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "satc__date"
  }, [_c('OnwardEndDate', {
    attrs: {
      "enddate": _vm.enddate,
      "minDate": _vm.fromDate,
      "label": _vm.i18n.set_end_date
    },
    on: {
      "update:enddate": function($event) {
        _vm.enddate = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "satc__actions"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('skip')
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n.skip))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n.confirm))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a1e02218!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/SubjectAssignTeacherToEventsConfirm.vue
// module id = 2074
// module chunks = 1